import { render, staticRenderFns } from "./ThgProducts.vue?vue&type=template&id=389b3ded&scoped=true&"
import script from "./ThgProducts.vue?vue&type=script&lang=ts&"
export * from "./ThgProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ThgProducts.vue?vue&type=style&index=0&id=389b3ded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b3ded",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRadioGroup,VSheet,VSkeletonLoader})
